/*
 * Copyright (C) Motorola Solutions, INC.
 * All Rights Reserved.
 */

import { HealthService } from './health.service';
import { HttpClient } from '@angular/common/http';
import { ServiceConfiguration, ServiceName } from '../../../assets/config/environment';
import { filter, take } from 'rxjs/operators';

export class KeycloakHealthService extends HealthService {
    private preferredKeycloakHost: string;
    public sessionHostUrl: string;
    constructor(http: HttpClient, serviceUrls: ServiceConfiguration[], healthEndpoint: string) {
        super(http, ServiceName.IDM, serviceUrls, healthEndpoint, true, false);
        this.initialized$.pipe(filter((init) => !!init), take(1))
            .subscribe(() => this.sessionHostUrl = this.activeUrl$.value);
    }

    // override keycloak health check initialization such that we prefer the keycloak host provided by the login cookie.
    protected override initializeHealthChecks() {
        this.setPreferredKeycloakHost();
        this.urls.sort((a, b) => this.keycloakServiceUrlPrioritySort(a, b, this.preferredKeycloakHost));
        console.debug(`Keycloak url sorted: ${this.urls.map((url) => url.url).join(', ')}`);
        this.runSequentialHealthCheckInitialization();
        // token refresh requests will only succeed if performed by the original instance that issued the token
        // scheduled health checks provide an idm server fallback that can perform a logout (clears http cookies and redirects to healthy instance)
        // regardless of if it actually hosts the session attempting to be terminated
        this.scheduleHealthChecks();
    }

    private setPreferredKeycloakHost() {
        const regExpMatchArray = document?.cookie?.match(new RegExp('(^| )CURRENT_KEYCLOAK_HOST=([^;]+)'));
        this.preferredKeycloakHost = regExpMatchArray ? decodeURIComponent(regExpMatchArray[2]) : undefined;
        console.debug(`Keycloak cookie preferred keycloak host url: ${this.preferredKeycloakHost}`);
    }

    // sorts the preferred keycloak host to the beginning of the urls list
    public keycloakServiceUrlPrioritySort(a: ServiceConfiguration, b: ServiceConfiguration, preferredKeycloakHost: string) {
        return Number(b.url === preferredKeycloakHost) - Number(a.url === preferredKeycloakHost);
    }

}
